module.exports = __webpack_public_path__ + "img/loadingbar2.fb83fc21.gif";